import { Divider, Flex, type OptionSelectionProps, SectionTitle } from '@shared/components';

import {
  BlockedInformationCreationFields,
  type BlockedInformationCreationFieldsProps,
} from '../blocked-information-creation-fields';
import { EmployeeInformationFields } from '../employee-information-fields';

import { type BaseFieldsProps } from './types';

export type StaffBlockedRecordInfoFormFieldProps = BlockedInformationCreationFieldsProps & {
  fields: {
    blockedType: BaseFieldsProps & { options: OptionSelectionProps[] };
    position: BaseFieldsProps;
    department: BaseFieldsProps;
  };
};

export default function StaffBlockedRecordInfoFormField(
  props: Readonly<StaffBlockedRecordInfoFormFieldProps>,
) {
  const { fields, options, visibleFields, slots } = props;

  return (
    <Flex
      sx={(theme) => ({
        flexDirection: 'column',
        gap: theme.spacing(6),
        p: theme.spacing(6),
      })}
    >
      <SectionTitle title='Person Information' />
      <EmployeeInformationFields
        fields={{
          blockedType: {
            mode: 'input',
            name: fields.blockedType.name,
            slotProps: {
              options: fields.blockedType.options,
              required: fields.blockedType.required,
            },
          },
          position: {
            mode: 'input',
            name: fields.position.name,
            slotProps: { required: fields.position.required },
          },
          department: {
            mode: 'input',
            name: fields.department.name,
            slotProps: { required: fields.department.required },
          },
        }}
        visibleFields={{
          position: true,
          department: true,
        }}
      />
      <Divider />
      <SectionTitle title='Blocklist Information' />
      <BlockedInformationCreationFields
        fields={{
          blockedAt: fields.blockedAt,
          blockedCourse: fields.blockedCourse,
          enforcementEnd: fields.enforcementEnd,
          reason: fields.reason,
          examCenter: fields.examCenter,
        }}
        visibleFields={visibleFields}
        options={options}
        slots={slots}
      />
    </Flex>
  );
}
